import React from "react";
import "./../styles/Dashboard.css";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useState, useEffect, useMemo } from "react";

const activeTileStyles = {
  boxShadow: "rgb(258, 71, 11, 0.8) 0px 0px 10px 10px",
};
export const DashBoardClinicalAudit = ({
  auditedNo,
  pendingNo,
  progressNo,
  completedNo,
  ...props
}) => {
  console.log(auditedNo, pendingNo, progressNo, completedNo);
  // const [auditedNo,setAuditedNo]=useState(0)

  // const [completedNo,setCompletedNo]=useState(0);
  // const [progressNo,setProgressNo]=useState(0);
  // const [pendingNo,setPendingNo]=useState(0);

  // const memoizedPendingData = useMemo(() => props.pendingData, [props.pendingData]);
  //     // if(props.auditedData)
  // // console.log(props.pendingData.body[0]['CountOfCases']['Disputed']);

  // useEffect(()=>{
  //   if(props.pendingData)
  //   {
  //   setAuditedNo(props.pendingData.body[0]['CountOfCases']['Disputed']);
  //   setCompletedNo(props.pendingData.body[0]['CountOfCases']['Completed']);
  //   setProgressNo(props.pendingData.body[0]['CountOfCases']['InProgress']);
  //   setPendingNo(props.pendingData.body[0]['CountOfCases']['Pending']);

  //   console.log(props.pendingData.body[0]['CountOfCases']['Disputed']);
  //   }

  // },[memoizedPendingData])

  return (
    <>
      {/* <Box className="cardbundle"> */}
      <Box
        className="cardbundle"
        style={{ maxWidth: "2160px", paddingTop: "3rem", marginBottom: "3rem" }}
      >
        <Grid container>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={10}>
              <Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
                &nbsp;
              </Grid>
              <Grid item xl={2.5} lg={2.5} md={2.5} sm={6} xs={12}>
                <Box
                  className="managerCard"
                  sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
                  onClick={props.handlePending}
                  style={props.activeStyle.pending ? activeTileStyles : {}}
                >
                  <img src="img/pending.svg" width="50" height="70" />
                  <Typography variant="h5">{pendingNo}</Typography>
                  <Typography
                    variant="h6"
                    sx={{ color: "#FB4E0B", textTransform: "uppercase" }}
                  >
                    Pending
                  </Typography>
                </Box>

                {/* {props.activeStyle.pending ? (
                  <img
                    src="img/polygon.svg"
                    width="50"
                    height="70"
                    style={{
                      alignContent: "center",
                      width: "100%",
                      padding: 20,
                    }}
                  />
                ) : (
                  ""
                )} */}
              </Grid>

              <Grid item xl={2.5} lg={2.5} md={2.5} sm={6} xs={12}>
                <Box
                  className="managerCard"
                  sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
                  onClick={props.handleInprogress}
                  style={props.activeStyle.inprogress ? activeTileStyles : {}}
                >
                  <img src="img/progress.svg" width="50" height="70" />
                  <Typography variant="h5">{progressNo} </Typography>
                  <Typography
                    variant="h6"
                    sx={{ color: "#FB4E0B", textTransform: "uppercase" }}
                  >
                    In-Progress
                  </Typography>
                </Box>

                {/* {props.activeStyle.inprogress ? (
                  <img
                    src="img/polygon.svg"
                    width="50"
                    height="70"
                    style={{
                      alignContent: "center",
                      width: "100%",
                      padding: 20,
                    }}
                  />
                ) : (
                  ""
                )} */}
              </Grid>
              <Grid item xl={2.5} lg={2.5} md={2.5} sm={6} xs={12}>
                <Box
                  className="managerCard"
                  sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
                  onClick={props.handleCompleted}
                  style={props.activeStyle.completed ? activeTileStyles : {}}
                >
                  <img src="img/completed.svg" width="50" height="70" />
                  <Typography variant="h5">{completedNo} </Typography>
                  <Typography
                    variant="h6"
                    sx={{ color: "#FB4E0B", textTransform: "uppercase" }}
                  >
                    Completed
                  </Typography>
                </Box>
                {/* {props.activeStyle.completed ? (
                  <img
                    src="img/polygon.svg"
                    width="50"
                    height="70"
                    style={{
                      alignContent: "center",
                      width: "100%",
                      padding: 20,
                    }}
                  />
                ) : (
                  ""
                )} */}
              </Grid>

              <Grid item xl={2.5} lg={2.5} md={2.5} sm={6} xs={12}>
                <Box
                  className="managerCard"
                  sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
                  onClick={props.handleAudited}
                  style={props.activeStyle.audited ? activeTileStyles : {}}
                >
                  <img src="img/audited.svg" width="50" height="70" />
                  <Typography variant="h5">{auditedNo} </Typography>
                  <Typography
                    variant="h6"
                    sx={{ color: "#FB4E0B", textTransform: "uppercase" }}
                  >
                    Rebuttal Raised
                  </Typography>
                </Box>

                {/* {props.activeStyle.audited ? (
                  <img
                    src="img/polygon.svg"
                    width="50"
                    height="70"
                    style={{
                      alignContent: "center",
                      width: "100%",
                      padding: 20,
                    }}
                  />
                ) : (
                  ""
                )} */}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

// <Box className="cardbundle" >
// <Grid container>
//     <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
//       <Grid container spacing={10}>
//         <Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
//          &nbsp;
//         </Grid>
//         <Grid item xl={2.5} lg={2.5} md={2.5} sm={6} xs={12}>
//           <Box
//             className="managerCard"
//             sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
//             onClick={props.handlePending}
//           >
//             <img src="img/pending.svg" width="50" height="70" />
//             <Typography variant="h5">
//               {0}
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{ color: "#FB4E0B", textTransform: "uppercase" }}
//             >
//               Pending
//             </Typography>
//           </Box>

//           {props.activeStyle.pending ? (
//             <img
//               src="img/polygon.svg"
//               width="50"
//               height="70"
//               style={{
//                 alignContent: "center",
//                 width: "100%",
//                 padding: 20
//               }}
//             />
//           ) : (
//             ""
//           )}
//         </Grid>

//         <Grid item xl={2.5} lg={2.5} md={2.5} sm={6} xs={12}>
//           <Box
//             className="managerCard"
//             sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
//             onClick={props.handleInprogress}
//           >
//             <img src="img/progress.svg" width="50" height="70" />
//             <Typography variant="h5">
//               {0}{" "}
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{ color: "#FB4E0B", textTransform: "uppercase" }}
//             >
//               In-Progress
//             </Typography>
//           </Box>

//           {props.activeStyle.inprogress ? (
//             <img
//               src="img/polygon.svg"
//               width="50"
//               height="70"
//               style={{
//                 alignContent: "center",
//                 width: "100%",
//                 padding: 20
//               }}
//             />
//           ) : (
//             ""
//           )}
//         </Grid>
//         <Grid item xl={2.5} lg={2.5} md={2.5} sm={6} xs={12}>
//           <Box
//             className="managerCard"
//             sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
//             onClick={props.handleCompleted}
//           >
//             <img src="img/completed.svg" width="50" height="70" />
//             <Typography variant="h5">
//               {0}{" "}
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{ color: "#FB4E0B", textTransform: "uppercase" }}
//             >
//               Completed
//             </Typography>
//           </Box>
//           {props.activeStyle.completed ? (
//             <img
//               src="img/polygon.svg"
//               width="50"
//               height="70"
//               style={{
//                 alignContent: "center",
//                 width: "100%",
//                 padding: 20
//               }}
//             />
//           ) : (
//             ""
//           )}
//         </Grid>

//         <Grid item xl={2.5} lg={2.5} md={2.5} sm={6} xs={12}>
//           <Box
//             className="managerCard"
//             sx={{ cursor: "pointer", backgroundColor: "#F5F5F5" }}
//             onClick={props.handleAudited}
//           >
//             <img src="img/audited.svg" width="50" height="70" />
//             <Typography variant="h5">
//               {0}{" "}
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{ color: "#FB4E0B", textTransform: "uppercase" }}
//             >
//               Audited
//             </Typography>
//           </Box>

//           {props.activeStyle.audited ? (
//             <img
//               src="img/polygon.svg"
//               width="50"
//               height="70"
//               style={{
//                 alignContent: "center",
//                 width: "100%",
//                 padding: 20
//               }}
//             />
//           ) : (
//             ""
//           )}
//         </Grid>

//       </Grid>
//     </Grid>
// </Grid>
// </Box>
